module.exports = __webpack_public_path__ + "4a11ed0cc5bbaa96d757bcf46b91cd24.mp3";